import {
  ActionType,
  ComponentType,
  ComponentTypeHelper,
  GuidHelper,
  IApplicationComponentModel,
  IApplicationComponentPropertyModel,
  IApplicationScreenModel,
  IApplicationScreenTypeModel,
  IApplicationsScreensSearchFilterModel,
  IAssetCollectionModel,
  IAssetModel,
  PlatformType,
  PropertyType,
  RecordStatus,
  ScreenType,
} from "@xala/common-services";
import {
  Button,
  Choose,
  ChooseOption,
  Col,
  Form,
  IChooseValue,
  Icon,
  IFormInstance,
  Input,
  Link,
  Row,
} from "@xala/common-ui";
import React from "react";
import { WithTranslation } from "react-i18next";
import { Action, ActionCreator } from "redux";
import { SelectAssetCollectionModal } from "../../../../../Asset/components/SelectAssetsCollectionModal";
import { SelectAssetsModal } from "../../../../../Asset/components/SelectAssetsModal";
import { ROUTES as AssetRoutes } from "../../../../../Asset/constants/routes";
import { ROUTES } from "../../../../../../constants";
import { ApplicationScreensBrowserModal } from "../../../../components/ApplicationScreensBrowserModal";
import {
  ActionTypeHelper,
  LEGACY_ACTION_PROPERTIES_TYPES,
  ScreenTypeHelper,
} from "../../../../helpers";
import { ActionPropertyModel } from "../../models";
import {
  ComponentPropertiesBase,
  IComponentPropertiesBaseProps,
  IComponentPropertiesBaseState,
} from "../ComponentPropertiesBase";
import "./ActionProperties.scss";

export interface IActionPropertiesStateProps {
  isProcessingData: boolean;
  screensTypes: IApplicationScreenTypeModel[];
}

export interface IActionPropertiesDispatchProps {
  selectScreensTypes: ActionCreator<Action>;
}

export interface IActionPropertiesOwnProps {
  allowedActionTypes?: ActionType[];
  actionTypeLabels?: Partial<Record<ActionType, string>>;
}

export interface IActionPropertiesProps
  extends IActionPropertiesStateProps,
    IActionPropertiesDispatchProps,
    IActionPropertiesOwnProps,
    IComponentPropertiesBaseProps,
    WithTranslation {}

export interface IActionPropertiesState extends IComponentPropertiesBaseState {
  applicationScreensBrowserVisible: boolean;
  assetsModalVisible: boolean;
  collectionsModalVisible: boolean;
}

export class ActionProperties extends ComponentPropertiesBase<
  IActionPropertiesProps,
  IActionPropertiesState,
  ActionPropertyModel
> {
  public componentDidMount() {
    const { selectScreensTypes } = this.props;

    selectScreensTypes();
  }

  public static defaultProps = {
    isProcessingData: false,
    allowedActionTypes: LEGACY_ACTION_PROPERTIES_TYPES,
  };

  public state: Readonly<IActionPropertiesState> = {
    applicationScreensBrowserVisible: false,
    assetsModalVisible: false,
    collectionsModalVisible: false,
  };

  formRef = React.createRef<IFormInstance>();

  constructor(props: IActionPropertiesProps, context?: any) {
    super(props, context);

    const { component, onComponentChange } = this.props;
    const { actionProperty, actionComponent } = this.getAction();

    this.properties.init(actionComponent);

    if (this.properties.ActionType) {
      if (!component.Properties) {
        component.Properties = [];
      }

      const actionPropertyIndex = component.Properties.findIndex(
        (row) => row.Name === "Action"
      );

      if (actionPropertyIndex < 0) {
        component.Properties.push(actionProperty);

        if (onComponentChange) {
          onComponentChange(component);
        }
      }
    }
  }

  getPropertiesModel(): ActionPropertyModel {
    const properties = new ActionPropertyModel();

    return properties;
  }

  getAction(): {
    actionProperty: IApplicationComponentPropertyModel;
    actionComponent: IApplicationComponentModel;
  } {
    const { component } = this.props;

    if (!component.Properties) {
      component.Properties = [];
    }

    const actionProperty = component.Properties.find(
      (row) => row.Name === "Action"
    ) || {
      Id: -1,
      Name: "Action",
      Guid: GuidHelper.newGuid(),
      RecordStatus: RecordStatus.Inserted,
      ApplicationComponentId: component.Id,
      IsEnumerable: false,
      PropertyType: PropertyType.Component,
    };

    const actionComponent =
      actionProperty.Value && actionProperty.Value.Component
        ? actionProperty.Value.Component
        : {
            Id: -1,
            ApplicationConfigurationId: component.ApplicationConfigurationId,
            ComponentTypeCode: ComponentType.Action,
            PlatformCode: PlatformType.Any,
            Guid: GuidHelper.newGuid(),
            RecordStatus: RecordStatus.Inserted,
            IsVisible: true,
            Sequence: 0,
            Name: ComponentTypeHelper.getDescription(ComponentType.Action),
            Properties: [],
          };

    if (!actionProperty.Value) {
      actionProperty.Value = {
        Id: -1,
        Guid: GuidHelper.newGuid(),
        ApplicationComponentPropertyId: actionProperty.Id,
        Component: actionComponent,
        RecordStatus: RecordStatus.Inserted,
        ApplicationComponentPropertyValueSequence: 0,
      };
    }

    return {
      actionProperty,
      actionComponent,
    };
  }

  onPropertyChange(propertyName: string) {
    const { component, onComponentChange } = this.props;
    const { actionProperty, actionComponent } = this.getAction();

    if (!component.Properties) {
      component.Properties = [];
    }

    if (propertyName === "ActionType") {
      const propertyIndex = component.Properties.findIndex(
        (row) => row.Name === "Action"
      );

      if (this.properties.ActionType) {
        if (propertyIndex < 0) {
          if (actionProperty.RecordStatus === RecordStatus.Deleted) {
            actionProperty.RecordStatus = RecordStatus.Updated;
          }

          component.Properties.push(actionProperty);

          if (
            (component.RecordStatus || RecordStatus.NoChange) ===
            RecordStatus.NoChange
          ) {
            component.RecordStatus = RecordStatus.Updated;
          }
        }
      } else {
        if (propertyIndex >= 0) {
          if (actionProperty.RecordStatus === RecordStatus.Inserted) {
            component.Properties.splice(propertyIndex, 1);
          } else {
            actionProperty.RecordStatus = RecordStatus.Deleted;
          }
        }
      }
    }

    this.properties.onPropertyChange(propertyName, actionComponent);

    if (onComponentChange) {
      onComponentChange(component);
    }
  }

  deleteProperty(propertyName: string) {
    const { component, onComponentChange } = this.props;
    const { actionComponent } = this.getAction();

    this.properties.deleteProperty(propertyName, actionComponent);

    if (onComponentChange) {
      onComponentChange(component);
    }
  }

  public onActionTypePropertyChange = (value?: IChooseValue) => {
    const { actionComponent } = this.getAction();

    switch (this.properties.ActionType) {
      case ActionType.OpenScreen:
        this.properties.ScreenType = undefined;
        this.properties.ScreenId = undefined;
        this.properties.ScreenName = undefined;

        this.properties.deleteProperty("ScreenTypeCode", actionComponent);
        this.properties.deleteProperty("ScreenId", actionComponent);
        this.properties.deleteProperty("ScreenName", actionComponent);
        break;
      case ActionType.OpenUrl:
        this.properties.Url = undefined;

        this.properties.deleteProperty("Url", actionComponent);
        break;
      case ActionType.CallTo:
        this.properties.PhoneNo = undefined;

        this.properties.deleteProperty("PhoneNo", actionComponent);
        break;
      case ActionType.EmailTo:
        this.properties.Email = undefined;

        this.properties.deleteProperty("Email", actionComponent);
        break;
      case ActionType.OpenMedia:
        this.properties.MediaId = undefined;
        this.properties.MediaName = undefined;

        this.properties.deleteProperty("MediaId", actionComponent);
        this.properties.deleteProperty("MediaName", actionComponent);
        break;
      case ActionType.OpenMediaCollection:
        this.properties.MediaCollectionId = undefined;
        this.properties.MediaCollectionName = undefined;

        this.properties.deleteProperty("MediaCollectionId", actionComponent);
        this.properties.deleteProperty("MediaCollectionName", actionComponent);
        break;
      case ActionType.NoAction:
        break;
    }

    this.properties.ActionType = ActionTypeHelper.getValue(
      value ? (value as string) : undefined
    );
    this.onPropertyChange("ActionType");
  };

  public renderActionTypeProperty = () => {
    const { isProcessingData, t, allowedActionTypes, actionTypeLabels } =
      this.props;

    const types = allowedActionTypes ?? LEGACY_ACTION_PROPERTIES_TYPES;

    return (
      <Form.Item
        name="ActionType"
        label={t("Action type")}
        initialValue={this.properties.ActionType}
      >
        <Choose
          allowClear={true}
          disabled={isProcessingData}
          placeholder={t("Select action type")}
          onChange={this.onActionTypePropertyChange}
        >
          {ActionTypeHelper.getOptions(types, actionTypeLabels)}
        </Choose>
      </Form.Item>
    );
  };

  public renderUrlProperty = () => {
    const { isProcessingData, t } = this.props;

    if (this.properties.ActionType !== ActionType.OpenUrl) {
      return null;
    }

    return (
      <Form.Item name="Url" label={t("Url")} initialValue={this.properties.Url}>
        <Input
          disabled={isProcessingData}
          placeholder={t("//")}
          onChange={(e) => {
            this.properties.Url = e.target.value;
            this.onPropertyChange("Url");
          }}
        />
      </Form.Item>
    );
  };

  public renderEmailProperty = () => {
    const { isProcessingData, t } = this.props;

    if (this.properties.ActionType !== ActionType.EmailTo) {
      return null;
    }

    return (
      <Form.Item
        name="Email"
        label={t("Email")}
        initialValue={this.properties.Email}
      >
        <Input
          disabled={isProcessingData}
          placeholder={t("")}
          onChange={(e) => {
            this.properties.Email = e.target.value;
            this.onPropertyChange("Email");
          }}
        />
      </Form.Item>
    );
  };

  public renderPhoneNoProperty = () => {
    const { isProcessingData, t } = this.props;

    if (this.properties.ActionType !== ActionType.CallTo) {
      return null;
    }

    return (
      <Form.Item
        name="PhoneNo"
        label={t("Phone no")}
        initialValue={this.properties.PhoneNo}
      >
        <Input
          disabled={isProcessingData}
          placeholder={t("")}
          onChange={(e) => {
            this.properties.PhoneNo = e.target.value;
            this.onPropertyChange("PhoneNo");
          }}
        />
      </Form.Item>
    );
  };

  public onScreenTypeChange = (value?: IChooseValue) => {
    const { actionComponent } = this.getAction();

    const screenTypeCode = value ? (value as string) : undefined;

    if (screenTypeCode) {
      this.properties.ScreenType = ScreenTypeHelper.getValue(screenTypeCode);
      this.properties.ScreenId = undefined;
      this.properties.ScreenName = undefined;

      this.properties.deleteProperty("ScreenId", actionComponent);
      this.properties.deleteProperty("ScreenName", actionComponent);

      this.formRef?.current?.resetFields(["ScreenId"]);
    } else {
      this.properties.ScreenType = undefined;
      this.properties.deleteProperty("ScreenType", actionComponent);

      this.formRef?.current?.resetFields(["ScreenType"]);
    }

    this.onPropertyChange("ScreenTypeCode");
  };

  public renderScreenTypeProperty = () => {
    const { isProcessingData, t, screensTypes } = this.props;

    if (this.properties.ActionType !== ActionType.OpenScreen) {
      return null;
    }

    return (
      <Form.Item
        name="ScreenType"
        label={t("Screen Type")}
        initialValue={this.properties.ScreenType}
      >
        <Choose
          allowClear={true}
          disabled={isProcessingData}
          placeholder={t("Select screen type")}
          onChange={this.onScreenTypeChange}
          showSearch
          optionFilterProp="children"
        >
          {screensTypes.map((screen) => (
            <ChooseOption key={screen.Code} value={screen.Code}>
              {screen.Name}
            </ChooseOption>
          ))}
        </Choose>
      </Form.Item>
    );
  };

  public onScreenPropertyCancel = () => {
    this.setState({ applicationScreensBrowserVisible: false });
  };

  public onScreenPropertySelect = (row: IApplicationScreenModel) => {
    this.properties.ScreenId = row.Id;
    this.properties.ScreenName = row.Name;
    this.onPropertyChange("ScreenId");
    this.onPropertyChange("ScreenName");

    this.setState({ applicationScreensBrowserVisible: false });
  };

  public onScreenPropertyClear = () => {
    const { component, onComponentChange } = this.props;
    const { actionComponent } = this.getAction();

    this.properties.ScreenId = undefined;
    this.properties.ScreenName = undefined;
    this.properties.deleteProperty("ScreenId", actionComponent);
    this.properties.deleteProperty("ScreenName", actionComponent);

    this.formRef?.current?.resetFields(["ScreenId"]);

    if (onComponentChange) {
      onComponentChange(component);
    }
  };

  public renderScreenProperty = () => {
    const { component, t } = this.props;
    const { applicationScreensBrowserVisible } = this.state;

    if (this.properties.ActionType !== ActionType.OpenScreen) {
      return null;
    }

    var filter: IApplicationsScreensSearchFilterModel = {
      ApplicationConfigurationId: component.ApplicationConfigurationId,
      IncludeDefinitions: true,
    };

    if (this.properties.ScreenType) {
      filter.ScreenTypeCode = this.properties.ScreenType;
    }

    let sourceValueView: React.ReactElement = this.properties.ScreenId ? (
      <label>
        <Link
          to={`${ROUTES.CONFIGURATION_SCREEN_DETAILS}/${this.properties.ScreenId}`}
        >
          {this.properties.ScreenName || this.properties.ScreenId}
        </Link>
      </label>
    ) : (
      <label>{t("SELECT_SCREEN", "Select screen")}</label>
    );

    return (
      <Form.Item
        name="ScreenId"
        label={t("SCREEN", "Screen")}
        initialValue={{
          key: `${this.properties.ScreenId}`,
          label: this.properties.ScreenName,
        }}
      >
        <Row gutter={8} style={{ justifyContent: "space-between" }}>
          <Col span={18}>
            <Form.Item>{sourceValueView}</Form.Item>
            <ApplicationScreensBrowserModal
              visible={applicationScreensBrowserVisible}
              filter={filter}
              onCancel={this.onScreenPropertyCancel}
              onSelect={this.onScreenPropertySelect}
            />
          </Col>
          <Col span={6} style={{ display: "flex", flex: "0" }}>
            {this.properties.ScreenId && (
              <Button
                icon={<Icon type="delete" />}
                onClick={this.onScreenPropertyClear}
                style={{ marginRight: "8px" }}
              />
            )}
            <Button
              icon={<Icon type="edit" />}
              onClick={() => {
                this.setState({ applicationScreensBrowserVisible: true });
              }}
            />
          </Col>
        </Row>
      </Form.Item>
    );
  };

  public onMediaPropertyCancel = () => {
    this.setState({ assetsModalVisible: false });
  };

  public onMediaPropertySelect = (row: IAssetModel) => {
    this.properties.MediaId = row.Id;
    this.properties.MediaName = row.Title;
    this.onPropertyChange("MediaId");
    this.onPropertyChange("MediaName");

    this.setState({ assetsModalVisible: false });
  };

  public onMediaPropertyClear = () => {
    const { component, onComponentChange } = this.props;
    const { actionComponent } = this.getAction();

    this.properties.MediaId = undefined;
    this.properties.MediaName = undefined;
    this.properties.deleteProperty("MediaId", actionComponent);
    this.properties.deleteProperty("MediaName", actionComponent);

    this.formRef?.current?.resetFields(["MediaId"]);

    if (onComponentChange) {
      onComponentChange(component);
    }
  };

  public renderMediaProperty = () => {
    const { t } = this.props;
    const { assetsModalVisible } = this.state;

    if (this.properties.ActionType !== ActionType.OpenMedia) {
      return null;
    }

    const hasPick =
      this.properties.MediaId != null &&
      this.properties.MediaName != null &&
      String(this.properties.MediaName).trim() !== "";

    let sourceValueView: React.ReactElement = hasPick ? (
      <label>
        <Link
          to={`${AssetRoutes.ASSET_DETAILS}/${this.properties.MediaId}`}
        >
          {this.properties.MediaName}
        </Link>
      </label>
    ) : (
      <label>{t("SELECT", "Select Media")}</label>
    );

    return (
      <Form.Item
        name="MediaId"
        label={t("MEDIA_LABEL", "Media")}
        initialValue={this.properties.MediaId}
      >
        <Row gutter={8} style={{ justifyContent: "space-between" }}>
          <Col span={18}>
            <Form.Item>{sourceValueView}</Form.Item>
            <SelectAssetsModal
              visible={assetsModalVisible}
              onClose={this.onMediaPropertyCancel}
              onSelect={this.onMediaPropertySelect}
            />
          </Col>
          <Col span={6} style={{ display: "flex", flex: "0" }}>
            {hasPick ? (
              <Button
                icon={<Icon type="delete" />}
                onClick={this.onMediaPropertyClear}
                style={{ marginRight: "8px" }}
              />
            ) : null}
            <Button
              icon={<Icon type="edit" />}
              onClick={() => {
                this.setState({ assetsModalVisible: true });
              }}
            />
          </Col>
        </Row>
      </Form.Item>
    );
  };

  public onMediaCollectionPropertyCancel = () => {
    this.setState({ collectionsModalVisible: false });
  };

  public onMediaCollectionPropertySelect = (row: IAssetCollectionModel) => {
    this.properties.MediaCollectionId = row.Id;
    this.properties.MediaCollectionName = row.Name;
    this.onPropertyChange("MediaCollectionId");
    this.onPropertyChange("MediaCollectionName");

    this.setState({ collectionsModalVisible: false });
  };

  public onMediaCollectionPropertyClear = () => {
    const { component, onComponentChange } = this.props;
    const { actionComponent } = this.getAction();

    this.properties.MediaCollectionId = undefined;
    this.properties.MediaCollectionName = undefined;
    this.properties.deleteProperty("MediaCollectionId", actionComponent);
    this.properties.deleteProperty("MediaCollectionName", actionComponent);

    this.formRef?.current?.resetFields(["MediaCollectionId"]);

    if (onComponentChange) {
      onComponentChange(component);
    }
  };

  public renderMediaCollectionProperty = () => {
    const { t } = this.props;
    const { collectionsModalVisible } = this.state;

    if (this.properties.ActionType !== ActionType.OpenMediaCollection) {
      return null;
    }

    const hasPick =
      this.properties.MediaCollectionId != null &&
      this.properties.MediaCollectionName != null &&
      String(this.properties.MediaCollectionName).trim() !== "";

    let sourceValueView: React.ReactElement = hasPick ? (
      <label>
        <Link
          to={`${AssetRoutes.ASSET_COLLECTION_DETAILS}/${this.properties.MediaCollectionId}`}
        >
          {this.properties.MediaCollectionName}
        </Link>
      </label>
    ) : (
      <label>
        {t(
          "NOTIFICATION_SELECT_ASSET_COLLECTION_FIELD",
          "Select Media Collection"
        )}
      </label>
    );

    return (
      <Form.Item
        name="MediaCollectionId"
        label={t("MEDIA_COLLECTION_LABEL", "Media Collection")}
        initialValue={this.properties.MediaCollectionId}
      >
        <Row gutter={8} style={{ justifyContent: "space-between" }}>
          <Col span={18}>
            <Form.Item>{sourceValueView}</Form.Item>
            <SelectAssetCollectionModal
              visible={collectionsModalVisible}
              onClose={this.onMediaCollectionPropertyCancel}
              onSelect={this.onMediaCollectionPropertySelect}
            />
          </Col>
          <Col span={6} style={{ display: "flex", flex: "0" }}>
            {hasPick ? (
              <Button
                icon={<Icon type="delete" />}
                onClick={this.onMediaCollectionPropertyClear}
                style={{ marginRight: "8px" }}
              />
            ) : null}
            <Button
              icon={<Icon type="edit" />}
              onClick={() => {
                this.setState({ collectionsModalVisible: true });
              }}
            />
          </Col>
        </Row>
      </Form.Item>
    );
  };

  // form: ActionProperties

  public render() {
    return (
      <React.Fragment>
        {this.renderActionTypeProperty()}
        {this.renderScreenTypeProperty()}
        {this.renderScreenProperty()}
        {this.renderUrlProperty()}
        {this.renderEmailProperty()}
        {this.renderPhoneNoProperty()}
        {this.renderMediaProperty()}
        {this.renderMediaCollectionProperty()}
      </React.Fragment>
    );
  }
}
